import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { impactMatrixHeader, priorityMatrix, urgencyMatrixHeader } from '../impact-matrix.component';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class ImpactMatrixService {
	private impactMatrixUrl = environment.baseApiUrl + 'register/impactMatrix';
	private impactUrl = environment.baseApiUrl + 'register/impactMatrix/impact';
	private urgencyUrl = environment.baseApiUrl + 'register/impactMatrix/urgency';
	private priorityUrl = environment.baseApiUrl + 'register/impactMatrix/priority';

	constructor(
		private http: HttpClient,
		private AuthLoginService: AuthLoginService
	) {}

	headers = new HttpHeaders({
		Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
		'Content-Type': 'application/json;charset=UTF-8',
	});

	getImpactMatrix(): Observable<{ impact: impactMatrixHeader[]; urgency: urgencyMatrixHeader[]; priority: priorityMatrix[][] }> {
		return this.http.get<any>(this.impactMatrixUrl, { headers: this.headers });
	}

	putImpactMatrix(
		impactArray: impactMatrixHeader[],
		toDeleteImpact: impactMatrixHeader[],
		urgencyArray: urgencyMatrixHeader[],
		toDeleteUrgency: urgencyMatrixHeader[],
		priorityArray: priorityMatrix[][]
	): Observable<any[]> {
		const impactToDelete = toDeleteImpact.map((impact) => {
			return impact.id;
		});
		const urgencyToDelete = toDeleteUrgency.map((urgency) => {
			return urgency.id;
		});
		const body = {
			impactArray: impactArray,
			toDeleteImpact: impactToDelete,
			urgencyArray: urgencyArray,
			toDeleteUrgency: urgencyToDelete,
			priorityArray: priorityArray,
		};
		return this.http.put<any[]>(this.impactMatrixUrl, body, { headers: this.headers });
	}

	// postImpactHeader(impactArray: impactMatrixHeader[]): Observable<any> {
	//   return this.http.post(this.impactUrl, impactArray, {headers: this.headers});
	// }

	// putImpactHeader(impactArray: impactMatrixHeader[]): Observable<any> {
	//   return this.http.put(this.impactUrl, impactArray, {headers: this.headers});
	// }

	// deleteImpactHeader(impactArray: impactMatrixHeader[]): Observable<any> {
	//   let impactToDelete = impactArray.map(impact => { return impact.id});
	//   console.log(impactToDelete);
	//   return this.http.delete(this.impactUrl, {headers: this.headers, params: {"idToDelete":impactToDelete}});
	// }

	// postUrgencyHeader(urgencyArray: urgencyMatrixHeader[]): Observable<any> {
	//   return this.http.post(this.urgencyUrl, urgencyArray, {headers: this.headers});
	// }

	// putUrgencyHeader(urgencyArray: urgencyMatrixHeader[]): Observable<any> {
	//   return this.http.put(this.urgencyUrl, urgencyArray, {headers: this.headers});
	// }

	// deleteUrgencyHeader(urgencyArray: urgencyMatrixHeader[]): Observable<any> {
	//   let urgencyToDelete = urgencyArray.map(urgency => { return urgency.id});
	//   return this.http.delete(this.urgencyUrl, {headers: this.headers, params: {"idToDelete":urgencyToDelete}});
	// }

	// postPriority(priorityArray: priorityMatrix[]): Observable<any> {
	//   return this.http.post(this.priorityUrl, priorityArray, {headers: this.headers});
	// }

	// putPriority(priorityArray: priorityMatrix[]): Observable<any> {
	//   return this.http.put(this.priorityUrl, priorityArray, {headers: this.headers});
	// }
}
